import { render, staticRenderFns } from "./UiUploadMulti.vue?vue&type=template&id=562adc10&scoped=true&"
import script from "./UiUploadMulti.vue?vue&type=script&lang=js&"
export * from "./UiUploadMulti.vue?vue&type=script&lang=js&"
import style0 from "./UiUploadMulti.vue?vue&type=style&index=0&id=562adc10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562adc10",
  null
  
)

export default component.exports